<template>
  <div class="listen-test-management1">
    <section>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="学员信息" name="first">
          <el-form :inline="true" class="form-style" size="mini" @submit.native.prevent>
            <el-form-item label="姓名">
              <el-input style="width: 250px" v-model="form1.realname" placeholder="请输入学员姓名" @keyup.enter.native="search"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="search">查询</el-button>
            </el-form-item>

            <br />

            <el-form-item label="所属班级">
              <el-input placeholder="请选择班级" v-model="form1.classnames" style="width: 250px" clearable @change="ClassChooseChange">
                <template slot="append">
                  <i class="el-icon-more" style="cursor: pointer" @click="ChooseClasses"></i>
                </template>
              </el-input>
            </el-form-item>

            <el-form-item label="类型">
              <el-select clearable v-model="form1.normal_state" placeholder="请选择" style="width: 150px">
                <el-option label="全部" value></el-option>
                <el-option label="试听" value="1"></el-option>
                <el-option label="在读" value="2"></el-option>
                <el-option label="已退学" value="4"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="状态">
              <el-select clearable v-model="form1.is_activate" placeholder="请选择" style="width: 150px">
                <el-option label="全部" value></el-option>
                <el-option label="已激活" value="1"></el-option>
                <el-option label="待激活" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-form>

          <el-divider></el-divider>

          <el-row>
            <el-col :span="24">
              <div>
                <el-button size="mini" type="primary" @click="AddFormalStudent">新增正式学员</el-button>

                <el-button size="mini" type="primary" @click="OpenMultiAdd">批量新增正式学员</el-button>
                <el-tooltip class="item" effect="dark" content="新建账号设置完有效期以后才可正常使用!" placement="top">
                  <el-button size="mini" type="primary" @click="SetRemainTime">设置账号有效期</el-button>
                </el-tooltip>

                <el-button size="mini" plain style="margin-left: 10px" @click="deleteStudents">删除账号</el-button>
                <el-button style="font-weight: bold; float: right;" size="mini" type="text" plain @click="GoVideoHelp">
                  <i class="el-icon-video-play el-icon--left"></i>视频演示
                </el-button>
                <el-button style="font-weight: bold; float: right;" size="mini" type="text" plain @click="GoHelp">
                  <i class="el-icon-help el-icon--left"></i>功能使用说明
                </el-button>
              </div>
            </el-col>
          </el-row>

          <div class="table-style">
            <el-table size="mini" :data="tableData" @selection-change="handleSelectionChange1" :header-cell-style="{ background: '#f5f7fa' }">
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column fixed="left" width="100" label="姓名">
                <template slot-scope="scope">
                  <span style="color: #409eff; cursor: pointer; font-weight: bold" type="primary" @click="UpateStudentInfo(scope.row)">{{ scope.row.studentUserInfo.realname }}</span>
                </template>
              </el-table-column>

              <el-table-column width="100" align="left" prop="sex" label="性别">
                <template slot-scope="scope">
                  <span>{{ scope.row.studentUserInfo.sex }}</span>
                </template>
              </el-table-column>

              <el-table-column width="150" align="left" prop="name" label="账号"></el-table-column>

              <el-table-column width="150" align="left" label="有效期">
                <template slot-scope="scope">
                  <span v-if="scope.row.normal_state == '2'">
                    <span v-if="scope.row.enddate">
                      {{ scope.row.enddate.slice(0, 10) }}
                    </span>
                    <span style="color: #e6a23c" v-else>请设置有效期</span>
                  </span>
                </template>
              </el-table-column>

              <el-table-column width="100" align="left" label="家校通">
                <template slot-scope="scope">
                  <span v-if="$store.state.user.schoolInfo.authorize">
                    <span v-if="scope.row.authorizer_openid">
                      <span v-if="scope.row.we_nickname">
                        {{ scope.row.we_nickname }}
                      </span>
                      <span v-else>已绑定</span>
                    </span>
                  </span>
                  <span v-else>
                    <span v-if="scope.row.openid">
                      <span v-if="scope.row.we_nickname">
                        {{ scope.row.we_nickname }}
                      </span>
                      <span v-else>已绑定</span>
                    </span>
                  </span>
                </template>
              </el-table-column>

              <el-table-column align="left" label="所在班级" width="200" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.class_str }}</span>
                </template>
              </el-table-column>

              <el-table-column width="150" align="left" label="联系电话">
                <template slot-scope="scope">
                  <span>{{ scope.row.studentUserInfo.parent_a }}</span>
                  <span>
                    {{ scope.row.studentUserInfo.parent_a_phone_num }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column width="150" align="left" label="家长微信">
                <template slot-scope="scope">
                  <span>{{ scope.row.studentUserInfo.parent_b }}</span>
                  <span>
                    {{ scope.row.studentUserInfo.parent_b_phone_num }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column width="150" align="left" label="公立校名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.studentUserInfo.school_name }}</span>
                </template>
              </el-table-column>

              <el-table-column width="150" align="left" label="在校年级">
                <template slot-scope="scope">
                  <!-- <span>{{ scope.row.studentUserInfo.grade }}</span> -->

                  <span v-if="scope.row.studentUserInfo.grade == '1'">幼儿园小班</span>
                  <span v-else-if="scope.row.studentUserInfo.grade == '2'">幼儿园中班</span>
                  <span v-else-if="scope.row.studentUserInfo.grade == '3'">幼儿园大班</span>
                  <span v-else-if="scope.row.studentUserInfo.grade == '4'">一年级</span>
                  <span v-else-if="scope.row.studentUserInfo.grade == '5'">二年级</span>
                  <span v-else-if="scope.row.studentUserInfo.grade == '6'">三年级</span>
                  <span v-else-if="scope.row.studentUserInfo.grade == '7'">四年级</span>
                  <span v-else-if="scope.row.studentUserInfo.grade == '8'">五年级</span>
                  <span v-else-if="scope.row.studentUserInfo.grade == '9'">六年级</span>
                  <span v-else-if="scope.row.studentUserInfo.grade == '10'">初一</span>
                  <span v-else-if="scope.row.studentUserInfo.grade == '11'">初二</span>
                  <span v-else-if="scope.row.studentUserInfo.grade == '12'">初三</span>
                  <span v-else-if="scope.row.studentUserInfo.grade == '13'">高一</span>
                  <span v-else-if="scope.row.studentUserInfo.grade == '14'">高二</span>
                  <span v-else-if="scope.row.studentUserInfo.grade == '15'">高三</span>
                </template>
              </el-table-column>

              <el-table-column width="150" align="left" label="负责人">
                <template slot-scope="scope">
                  <span>{{ scope.row.studentUserInfo.leaderName }}</span>
                </template>
              </el-table-column>

              <el-table-column width="150" align="left" prop="normal_state" label="学员状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.normal_state == '1'">试听</span>
                  <span v-else-if="scope.row.normal_state == '2'">在读</span>
                  <span v-else-if="scope.row.normal_state == '3'">休学</span>
                  <span v-else-if="scope.row.normal_state == '4'">已退学</span>
                  <span v-else>未知</span>
                </template>
              </el-table-column>

              <el-table-column width="150" align="left" prop="created_time" label="录入时间"></el-table-column>

              <el-table-column align="left" label="所属校区" width="150">
                <template slot-scope="scope">
                  <span>{{ scope.row.campusName }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" width="100" prop="name" label="操作" fixed="right">
                <template slot-scope="scope">
                  <el-dropdown v-if="scope.row.normal_state == '2'">
                    <span class="el-dropdown-link">
                      操作
                      <i class="el-icon-arrow-down"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native="getQrCode(scope.row)" v-if="
                          $store.state.user.schoolInfo.authorize &&
                            !scope.row.authorizer_openid
                        ">绑定微信</el-dropdown-item>
                      <el-dropdown-item @click.native="getQrCode(scope.row)" v-else-if="
                          !$store.state.user.schoolInfo.authorize &&
                            !scope.row.openid
                        ">绑定微信</el-dropdown-item>

                      <el-dropdown-item @click.native="deleteStuUserOpenId(scope.row)" v-if="
                          $store.state.user.schoolInfo.authorize &&
                            scope.row.authorizer_openid
                        ">解绑微信</el-dropdown-item>
                      <el-dropdown-item @click.native="deleteStuUserOpenId(scope.row)" v-else-if="
                          !$store.state.user.schoolInfo.authorize &&
                            scope.row.openid
                        ">解绑微信</el-dropdown-item>

                      <el-dropdown-item @click.native="updateStuUserPassword(scope.row)">重置密码</el-dropdown-item>

                      <el-dropdown-item @click.native="quitBackSchool(scope.row, '4')">退学</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>

                  <el-button v-if="scope.row.normal_state == '4'" size="mini" type="text" @click="quitBackSchool(scope.row, '2')">复学</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagination-style">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page_no" :page-sizes="[10, 15, 20, 30, 40, 50, 100]" :page-size="page_size" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </section>

    <!--修改学员信息-->
    <el-dialog width="80%" title="修改信息" :visible.sync="dialogFormVisible7">
      <el-form ref="updateform" label-width="120px" class="form-style" :model="updateform" :rules="rules" size="mini">
        <el-row>
          <el-col :span="12">
            <div>
              <el-form-item label="学员姓名" required prop="realname">
                <el-input v-model="updateform.realname" style="width: 300px" placeholder="请输入学员姓名"></el-input>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="12">
            <div>
              <el-form-item label="学员账号" required prop="name">
                <el-input v-model="updateform.name" style="width: 300px" placeholder="学员账号默认为家长A手机号,密码为123456"></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <div>
              <el-form-item label="学员性别" required prop="sex">
                <el-radio-group v-model="updateform.sex">
                  <el-radio label="男"></el-radio>
                  <el-radio label="女"></el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div>
              <el-form-item label="出生日期">
                <el-date-picker type="date" placeholder="请选择出生日期" v-model="updateform.birthday" style="width: 300px" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <div>
              <el-form-item label="所在学校">
                <el-input v-model="updateform.school_name" style="width: 300px" placeholder="请输入所在公立学校"></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div>
              <el-form-item label="在校年级">
                <el-select v-model="updateform.grade" placeholder="请选择在校年级" style="width: 300px">
                  <el-option label="幼儿园小班" :value="1"></el-option>
                  <el-option label="幼儿园中班" :value="2"></el-option>
                  <el-option label="幼儿园大班" :value="3"></el-option>
                  <el-option label="一年级" :value="4"></el-option>
                  <el-option label="二年级" :value="5"></el-option>
                  <el-option label="三年级" :value="6"></el-option>
                  <el-option label="四年级" :value="7"></el-option>
                  <el-option label="五年级" :value="8"></el-option>
                  <el-option label="六年级" :value="9"></el-option>
                  <el-option label="初一" :value="10"></el-option>
                  <el-option label="初二" :value="11"></el-option>
                  <el-option label="初三" :value="12"></el-option>
                  <el-option label="高一" :value="13"></el-option>
                  <el-option label="高二" :value="14"></el-option>
                  <el-option label="高三" :value="15"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <div>
              <el-form-item label="联系电话" required prop="parent_a_phone_num">
                <el-select v-model="updateform.parent_a" style="width: 100px">
                  <el-option label="父亲" value="父亲"></el-option>
                  <el-option label="母亲" value="母亲"></el-option>
                  <el-option label="其他" value="其他"></el-option>
                </el-select>
                <el-input v-model="updateform.parent_a_phone_num" placeholder="请输入手机号" style="width: 180px; margin-left: 20px"></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div>
              <el-form-item label="家长微信" prop="parent_b_phone_num">
                <el-select v-model="updateform.parent_b" style="width: 100px">
                  <el-option label="父亲" value="父亲"></el-option>
                  <el-option label="母亲" value="母亲"></el-option>
                  <el-option label="其他" value="其他"></el-option>
                </el-select>
                <el-input v-model="updateform.parent_b_phone_num" placeholder="请输入手机号" style="width: 180px; margin-left: 20px"></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <div>
              <el-form-item label="主责任人" required prop="leader">
                <el-select v-model="updateform.leader" placeholder="请选择主责任人" style="width: 300px">
                  <el-option v-for="item in user_list" :key="item.id" :label="item.realname + '(' + item.name + ')'" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <div>
              <el-form-item label="所属校区">
                <el-select v-model="updateform.educational_institution_campus_id" placeholder="请选择所属校区" style="width: 300px" @change="getCampusUserList" disabled>
                  <el-option v-for="(item, index) of school_list" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="12">
            <div>
              <el-form-item label="备注信息">
                <el-input style="width: 300px" type="textarea" v-model="updateform.remark"></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible7 = false">取 消</el-button>
        <el-button size="small" type="primary" @click="addOrUpdateNormalStudent('updateform')">修 改</el-button>
      </div>
    </el-dialog>

    <el-dialog title="添加学员" :visible.sync="dialogVisible" width="50%">
      <el-row>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-upload action="/" :on-change="onChange" :auto-upload="false" :show-file-list="false" accept=".xls, .xlsx">
              <el-button size="mini">
                导入学员信息
                <i class="el-icon-upload el-icon--right"></i>
              </el-button>
            </el-upload>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple-light">
            <el-tooltip placement="top">
              <div slot="content">
                【注意事项】
                <br />1、学员账号为6-20位字母或数字组成,不能包含特殊字符,推荐以学员家长手机号作为平台账号;
                <br />2、性别统一以中文输入"男"或者"女";
                <br />3、所有字段内容不能为空;
                <br />4、批量导入每次最多导入50人; <br />5、默认密码为{{$store.state.globalCheck.defaultPassword}}
                <br />
                <br />【录入示例】 <br />王晓明 男 18722160555
              </div>
              <el-link style="float: right" icon="el-icon-document" @click="DownLoadExcel">下载Excel模板</el-link>
            </el-tooltip>
          </div>
        </el-col>
      </el-row>

      <el-table size="mini" height="300" :data="outputs" style="width: 100%; margin-top: 20px" :header-cell-style="{ background: '#f5f7fa' }" :row-class-name="tableRowClassName">
        <el-table-column prop="realname" label="姓名" align="center"></el-table-column>
        <el-table-column prop="sex" label="性别" align="center"></el-table-column>
        <el-table-column prop="username" label="账号" align="center"></el-table-column>

        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="Deleteoutputs(scope.$index)">移除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="ClearMultiStudent">暂不添加</el-button>

        <el-button size="small" type="primary" @click="MultiAddStudent">确认添加</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="'学员姓名:' + stu_name" :visible.sync="dialogVisible1" width="260px" :before-close="handleClose">
      <div style="text-align: center; margin-top: -20px">
        <el-image style="width: 200px; height: 200px" :src="code_url" fit="fill"></el-image>
      </div>

      <div style="text-align: center">
        <span>请家长用微信扫码,绑定账号</span>
      </div>
    </el-dialog>

    <el-dialog title="设置有效期" :visible.sync="dialogVisible2" width="500px" @close="CloseTimeDialog">
      <el-form size="small" ref="form" :model="form2" label-width="80px">
        <el-form-item label="设置方式">
          <el-select v-model="form2.type" placeholder="请选择设置方式" style="width: 360px">
            <el-option label="按固定日期设置" value="1"></el-option>
            <el-option label="按开通天数设置" value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="有效期至" v-if="form2.type == '1'">
          <el-date-picker style="width: 360px" v-model="form2.end_date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" @change="DateChange" placement="bottom-start"></el-date-picker>
        </el-form-item>

        <el-form-item label="开通天数" v-if="form2.type == '2'">
          <el-input-number v-model="form2.num" @change="DayChange" label="请输入开通天数" style="width: 360px" :min="0"></el-input-number>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible2 = false">取 消</el-button>
        <el-button size="small" type="primary" @click="bulkAddStudentUserRemainTime">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="班级列表" :visible.sync="dialogVisible3" width="80%">
      <el-form size="mini" :inline="true" ref="ruleForm" :model="ruleForm">
        <el-form-item label="班级名称">
          <el-input style="width: 250px" clearable v-model="ruleForm.classname" placeholder="请输入班级名称"></el-input>
        </el-form-item>

        <el-form-item label="上课老师" prop="lecturer_id">
          <el-select v-model="ruleForm.lecturer_id" style="width: 200px" clearable>
            <el-option :label="item.realName + ' ' + '(' + item.name + ')'" :value="item.id" v-for="(item, index) of teacherList" :key="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="search2" icon="el-icon-search">查询</el-button>
        </el-form-item>
      </el-form>

      <el-table size="mini" :data="tableData1" :header-cell-style="{ background: '#f5f7fa' }" @selection-change="handleSelectionChange2">
        <el-table-column type="selection" width="55"></el-table-column>

        <el-table-column fixed="left" width="200" prop="name" label="班级名称">
          <template slot-scope="scope">
            <span style="color: #409eff; cursor: pointer; font-weight: bold" type="primary" @click="UpateClassInfo(scope.row)">{{ scope.row.name }}</span>
          </template>
        </el-table-column>

        <el-table-column width="100" align="left" label="班级类型">
          <template slot-scope="scope">
            <span v-if="scope.row.curriculum_class_type == '1'">正式班</span>
            <span v-else-if="scope.row.curriculum_class_type == '2'">试听班</span>
          </template>
        </el-table-column>

        <el-table-column prop="campun_name" width="200" align="left" label="所属校区"></el-table-column>

        <el-table-column align="left" width="100" label="科目">
          <template slot-scope="scope">{{ scope.row.subject_name }}</template>
        </el-table-column>

        <el-table-column width="200" align="left" label="课程名称">
          <template slot-scope="scope">{{
            scope.row.curriculum_name
          }}</template>
        </el-table-column>

        <el-table-column align="left" width="150" prop="lecturer_realname" label="上课老师"></el-table-column>

        <el-table-column align="left" width="200" label="上课时间" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{ scope.row.week_str }}
            {{ scope.row.time_str }}
          </template>
        </el-table-column>

        <el-table-column align="center" width="50" label="人数">
          <template slot-scope="scope">
            <span v-if="scope.row.course_num">
              {{ scope.row.student_total_num }}
            </span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="课程进度" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.course_num">{{ scope.row.signNum }} / {{ scope.row.course_num }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" prop="start_date" label="开班日期" width="200"></el-table-column>

        <el-table-column align="left" prop="end_date" label="结课日期" width="200"></el-table-column>
      </el-table>

      <div class="pagination-style">
        <el-pagination @current-change="handleCurrentChange2" :current-page.sync="page_no2" layout="total, prev, pager, next" :total="total2"></el-pagination>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible3 = false">取 消</el-button>
        <el-button size="small" type="primary" @click="ConformChooseClass">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getFormalStudentList,
  getStudentNormalClassList,
  getCampusUserList,
  addOrUpdateNormalStudent,
  getEducationalInstitutionCampusList,
  deleteStudents,
  quitSchool,
  backSchool,
  bulkAddNormalStudent,
  getQrCode,
  deleteStuUserOpenId,
  bulkAddStudentUserRemainTime,
  getClassesList,
  // getCampusTeacherList,
  updateStuUserPassword,
} from '@/api/educational.js'
import { api_eduCampusSelectTchListByCampus } from '@/api/javaApi'
import XLSX from 'xlsx'

import { Daysdiff, shortTime } from '@/config/utils'

import CryptoJS from 'crypto-js'

export default {
  name: 'studentmanagement',

  data() {
    var validatePass = (rule, value, callback) => {
      if (!/^1[1234567890]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    var validatePhone = (rule, value, callback) => {
      if (value && !/^1[1234567890]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }

    var validate_username = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入账号'))
      }
      if (!/^[a-zA-Z0-9]{6,20}$/.test(value)) {
        callback(new Error('账号必须为6-20位字母或数字组成'))
      } else {
        callback()
      }

      if (!this.checkSpecialKey(value)) {
        callback(new Error('不能含有特殊字符！！'))
      } else {
        callback()
      }
    }

    return {
      dialogVisible: false,
      rules: {
        sex: [
          {
            required: true,
            message: '请选择性别',
            trigger: 'change',
          },
        ],

        leader: [
          {
            required: true,
            message: '请选择主负责人',
            trigger: 'change',
          },
        ],

        name: [
          { validator: validate_username, trigger: 'blur' },
          {
            required: true,
            message: '请输入账号',
            trigger: 'change',
          },
        ],

        state: [
          {
            required: true,
            message: '请选择客户状态',
            trigger: 'change',
          },
        ],

        nickname: [
          {
            required: true,
            message: '请输入学生昵称',
            trigger: 'change',
          },
        ],
        realname: [
          {
            required: true,
            message: '请输入学员姓名',
            trigger: 'change',
          },
        ],
        parent_a_phone_num: [
          { required: true, message: '请输入联系电话', trigger: 'change' },
          { validator: validatePass, trigger: 'blur' },
        ],
        parent_b_phone_num: [{ validator: validatePhone, trigger: 'change' }],
      },

      //分页参数
      page_no: 1,
      page_size: 20,
      total: 0,

      //意向学员转公开课试听学员
      state: '1',

      gridData: [], //学员听过的讲次
      gridData1: [], // 入班讲次列表
      educational_institution_campus_id: '', //当前学生校区ID

      //调班参数

      student_user_id: '',
      now_class_id: '',

      changeform: {
        className: '',
        curriculum_id: '',
        now_class_id: '',
      },

      page_no1: 1,
      page_size1: 10,
      total1: 0,

      //学员查询
      form1: {
        realname: '',
        leader: '',
        phone_a_num: '',
        normal_state: '2',
        educational_institution_campus_id: '',
        classnames: '',
        classIds: [],
        is_activate: '',
      },

      dialogFormVisible: false,

      dialogFormVisible7: false, //修改学员信息
      outerVisible: false,

      teaching_plan_list: [], //所选教学计划ID

      activeName: 'first',
      name: '',
      tableData: [],

      //学员在读班级
      stuClassList: [],
      stuChange_ClassList: [],
      outerVisible1: false, //调班页面
      outerVisible2: false, //目标调入班级
      target_change_class: {},

      school_list: [],
      user_list: [],

      updateform: {
        id: '',
        name: '',
        realname: '',
        sex: '',
        grade: '',
        parent_a: '',
        parent_a_phone_num: '',
        nickname: '',
        school_name: '',
        birthday: '',
        parent_b: '',
        parent_b_phone_num: '',
        state: '',
        leader: '',
        remark: '',
        educational_institution_campus_id: '',
      },

      chooseStudents: [], //选择的学员
      chooseStu_current: [], //选择的学员ID组

      //批量导入功能
      fileData: '', // 保存选择的文件数据
      outputs: [], // 保存读取出来的数据列表
      has_error: false,

      //微信绑定
      code_url: '',
      dialogVisible1: false,
      stu_name: '',

      //有效期设置
      dialogVisible2: false,
      form2: {
        type: '1',
        end_date: '',
        num: null,
      },
      stuRemainTimeDataArr: [], //有效期参数列表

      //搜索正式班级
      dialogVisible3: false,
      //搜索正式班级
      ruleForm: {
        search_type: '',
        lecturer_id: '',
        classname: '',
        search_value: '',
        subject_id: '',
        curriculum_id: '',
        teaching_type: '',
        class_start_time: '',
        class_end_time: '',
        course_type: '',
        course_state: [],
        educational_institution_campus_id: '', //所属校区
        startdate: [], //开班日期
        enddate: [], //结课日期
        end_class_state: '0', // 班级是否结业
      },
      tableData1: [], //正式班级列表
      teacherList: [], //教师列表
      teacherListTo: [], //助教
      page_no2: 1,
      page_size2: 10,
      total2: 0,
      ChooseClassData: [], //已选择的班级
    }
  },

  watch: {
    '$store.state.user.selected_schools': {
      handler(newValue, oldValue) {
        console.log('校区监听')
        console.log(newValue)
        console.log(oldValue)
        if (newValue.length == 0) {
          this.$message.warning('目标校区不能为空')
        } else if (newValue.length == 1) {
          this.getFormalStudentList()
        } else {
          this.getFormalStudentList()
        }
      },
      deep: true,
    },
  },
  mounted() {
    if (this.$store.state.user.selected_schools.length == 0) {
      this.$message.warning('请选择校区')
    } else if (this.$store.state.user.selected_schools.length == 1) {
      this.getFormalStudentList()
    } else {
      this.getFormalStudentList()
    }

    this.getEducationalInstitutionCampusList()
  },
  methods: {
    handleClose() {
      this.getFormalStudentList()
      this.dialogVisible1 = false
    },

    GoHelp() {
      window.open(
        'https://steamfun.yuque.com/docs/share/e4883f90-a218-45b6-8ae1-0a3498a63d96?'
      )
    },

    GoVideoHelp() {
      window.open(
        'https://wugecdn.steam.fun/videos/g_HelpCenter/%E6%95%99%E5%8A%A1%E4%B8%AD%E5%BF%83/%E5%A6%82%E4%BD%95%E5%BD%95%E5%85%A5%E5%B9%B6%E6%BF%80%E6%B4%BB%E5%AD%A6%E7%94%9F%E8%B4%A6%E5%8F%B7.mp4'
      )
    },

    checkSpecialKey(str) {
      let specialKey =
        "[`~!#$^&*()=|{}':;'\\[\\].<>/?~！#￥……&*（）——|{}【】‘；：”“'。，、？]‘'"
      for (let i = 0; i < str.length; i++) {
        if (specialKey.indexOf(str.substr(i, 1)) != -1) {
          return false
        }
      }
      return true
    },

    //重置学生密码
    updateStuUserPassword(row) {
      this.$confirm(`确定将密码重置为${this.$store.state.globalCheck.defaultPassword}吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        updateStuUserPassword({
          stuId: row.id,
          password: CryptoJS.MD5(this.$store.state.globalCheck.defaultPassword).toString(
            CryptoJS.enc.Base64
          ),
        }).then((res) => {
          console.log('重置密码')
          console.log(res)
          this.$message.success('重置成功')
        })
      })
    },

    //学生退学操作
    quitBackSchool(row, cmd) {
      console.log('学生退学操作')

      if (cmd == '4') {
        this.$confirm(
          '确定对该学员进行退学操作吗? 退学后学员将不能再登录系统！',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        ).then(() => {
          quitSchool({
            id: row.id,
          }).then((res) => {
            console.log('学生退学')
            console.log(res)
            this.$message.success('退学成功')

            this.getFormalStudentList()
          })
        })
      } else if (cmd == '2') {
        this.$confirm(
          '确定对该学员进行复学操作吗? 复学后,需重新激活账号后再登录系统。',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        ).then(() => {
          backSchool({
            id: row.id,
          }).then((res) => {
            console.log('学生复学')
            console.log(res)
            this.$message.success('复学成功')

            this.getFormalStudentList()

          })
        })
      }
    },

    getEducationalInstitutionCampusList() {
      getEducationalInstitutionCampusList().then((res) => {
        console.log('获得分校列表')
        console.log(res)
        this.school_list = res.educational_institution_campus_list
      })
    },

    //修改学员信息
    UpateStudentInfo(row) {
      console.log('修改学员信息')
      console.log(row)
      //TODO 学员信息
      this.updateform.realname = row.studentUserInfo.realname
      this.updateform.sex = row.studentUserInfo.sex
      this.updateform.birthday = row.studentUserInfo.birthday
      this.updateform.school_name = row.studentUserInfo.school_name
      this.updateform.grade = row.studentUserInfo.grade
      this.updateform.parent_a = row.studentUserInfo.parent_a
      this.updateform.parent_a_phone_num =
        row.studentUserInfo.parent_a_phone_num
      this.updateform.parent_b = row.studentUserInfo.parent_b
      this.updateform.parent_b_phone_num =
        row.studentUserInfo.parent_b_phone_num
      this.updateform.leader = row.studentUserInfo.leader
      this.updateform.state = row.state
      this.updateform.educational_institution_campus_id =
        row.educational_institution_campus_id
      this.updateform.remark = row.studentUserInfo.remark
      this.updateform.id = row.id
      this.updateform.name = row.name
      this.dialogFormVisible7 = true
      this.getEducationalInstitutionCampusList()
      this.getCampusUserList()
    },

    //修改正式学员信息
    addOrUpdateNormalStudent(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addOrUpdateNormalStudent({
            studentId: this.updateform.id,
            name: this.updateform.name,
            realname: this.updateform.realname,
            sex: this.updateform.sex,
            grade: this.updateform.grade,
            parent_a: this.updateform.parent_a,
            parent_a_phone_num: this.updateform.parent_a_phone_num,
            nickname: this.updateform.nickname,
            school_name: this.updateform.school_name,
            birthday: this.updateform.birthday,
            parent_b: this.updateform.parent_b,
            parent_b_phone_num: this.updateform.parent_b_phone_num,
            state: this.updateform.state,
            leader: this.updateform.leader,
            remark: this.updateform.remark,
            educational_institution_campus_id: this.updateform
              .educational_institution_campus_id,
          }).then((res) => {
            console.log('修改学员信息')
            console.log(res)
            if (res.is_update) {
              this.$message.success('修改成功')
              this.dialogFormVisible7 = false
              this.getFormalStudentList()
            }
          })
        }
      })
    },

    chooseClass(val) {
      console.log('子组件传值')
      console.log(val)
      this.form.chooseClassinfo = val
      this.curriculum_class_price = val.goods_price
      this.haschoose_class = true
    },

    //选择班级列表
    ChooseClasses() {
      console.log('选择班级列表')
      this.dialogVisible3 = true
      this.getClassesList()
      this.getCampusTeacherList()
    },

    //选择学员
    handleSelectionChange1(selection) {
      this.chooseStudents = selection
      console.log('正式学员列表')
      console.log(this.chooseStudents)

      this.chooseStu_current = []

      for (let k = 0; k < selection.length; k++) {
        this.chooseStu_current.push(selection[k].id)
      }
    },

    handleSelectionChange2(selection) {
      console.log('选择班级')
      console.log(selection)

      this.ChooseClassData = selection
    },

    ConformChooseClass() {
      if (this.ChooseClassData.length == 0) {
        this.$message.warning('请选择班级')
        return
      }

      var classinfo = []
      this.form1.classIds = []

      for (let k = 0; k < this.ChooseClassData.length; k++) {
        classinfo.push(this.ChooseClassData[k].name)
        this.form1.classIds.push(this.ChooseClassData[k].id)
      }

      this.form1.classnames = classinfo.join(',')
      this.dialogVisible3 = false
    },

    //获得校区员工列表
    getCampusUserList() {
      getCampusUserList({
        campusId: this.updateform.educational_institution_campus_id,
      }).then((res) => {
        console.log('获得学校用户列表')
        console.log(res)
        this.user_list = res.campusUserList
      })
    },

    //查询所有正式学员
    getFormalStudentList() {
      console.log('查询学员提交的参数')
      console.log(this.form1)
      getFormalStudentList({
        realname: this.form1.realname,
        leader: this.form1.leader,
        phone_a_num: this.form1.phone_a_num,
        // normal_state: this.form1.normal_state,
        campusIds: JSON.stringify(this.$store.state.user.selected_schools),
        classIds: JSON.stringify(this.form1.classIds),
        is_activate: this.form1.is_activate,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log('查询所有正式学员')
        console.log(res)
        this.tableData = res.studentList

        //班级列表转字符串

        for (let k = 0; k < this.tableData.length; k++) {
          this.tableData[k].classlist = []
          for (let j = 0; j < this.tableData[k].stuClassArr.length; j++) {
            // console.log(this.tableData[k].stuClassArr[j].classInfo.name);
            this.tableData[k].classlist.push(
              this.tableData[k].stuClassArr[j].classInfo.name
            )
          }

          //  console.log(this.tableData[k].classlist);
          this.tableData[k].class_str = this.tableData[k].classlist.join(' , ')
        }

        this.total = res.total
      })
    },

    AddFormalStudent() {
      if (
        this.$store.state.user.selected_schools.length == 0 ||
        this.$store.state.user.selected_schools.length > 1
      ) {
        this.$message.warning('请选择1个目标校区')
      } else {
        this.$router.push({
          name: 'addnewstudent',
        })
      }
    },

    SetRemainTime() {
      if (this.chooseStudents.length == 0) {
        this.$message.warning('请选择学员')
        return
      }
      this.dialogVisible2 = true

      console.log('校区到期时间')
      console.log(this.$store.state.user.schoolInfo.offTime)
    },

    DateChange() {
      console.log('有效期设置改变')
      console.log(this.form2.end_date)

      var check_num = 0
      check_num = Daysdiff(this.form2.end_date, shortTime(new Date()))
      if (check_num < 1) {
        this.$message.warning('有效期必须大于1天')
        return
      }

      var stuData = {}
      var num = 0
      this.stuRemainTimeDataArr = []

      for (let k = 0; k < this.chooseStudents.length; k++) {
        if (this.chooseStudents[k].enddate) {
          num = Daysdiff(
            this.form2.end_date,
            shortTime(this.chooseStudents[k].enddate)
          )
        } else {
          num = Daysdiff(this.form2.end_date, shortTime(new Date()))
        }

        stuData = {
          stuId: this.chooseStudents[k].id,
          campusId: this.chooseStudents[k].educational_institution_campus_id,
          stu_enddate: this.chooseStudents[k].enddate,
          num: num,
        }

        this.stuRemainTimeDataArr.push(stuData)
      }

      console.log('学员有效期列表')
      console.log(this.stuRemainTimeDataArr)
    },

    DayChange() {
      console.log('有效天数改变')
      console.log(this.form2.num)

      var stuData = {}

      if (this.form2.num < 0 || this.form2.num == 0) {
        this.$message.warning('开通天数必须大于1天')
        this.stuRemainTimeDataArr = []
        return
      }

      this.stuRemainTimeDataArr = []

      for (let k = 0; k < this.chooseStudents.length; k++) {
        stuData = {
          stuId: this.chooseStudents[k].id,
          campusId: this.chooseStudents[k].educational_institution_campus_id,
          stu_enddate: this.chooseStudents[k].enddate,
          num: this.form2.num,
        }

        this.stuRemainTimeDataArr.push(stuData)
      }

      console.log('学员有效期列表')
      console.log(this.stuRemainTimeDataArr)
    },

    //正式学员账号时长设置
    bulkAddStudentUserRemainTime() {
      if (this.stuRemainTimeDataArr.length == 0) {
        this.$message.warning('请正确设置学员有效期')
        return
      }

      bulkAddStudentUserRemainTime({
        stuRemainTimeDataArr: JSON.stringify(this.stuRemainTimeDataArr),
      }).then((res) => {
        console.log('批量增加时长')
        console.log(res)
        if (res.is_update) {
          this.$message.success('有效期设置成功')
          this.getFormalStudentList()
          this.dialogVisible2 = false
        }
      })
    },

    CloseTimeDialog() {
      console.log('关闭有效期设置')
      this.form2.end_date = ''
      this.form2.num = null
    },

    search() {
      this.page_no = 1
      this.getFormalStudentList()
    },

    search1() {
      this.page_no1 = 1
      this.getClassListForStuChangeClass()
    },

    search2() {
      this.page_no2 = 1
      this.getClassesList()
    },

    // 获取班级列表
    getClassesList() {
      getClassesList({
        campusIds: JSON.stringify(this.$store.state.user.selected_schools),
        curriculum_class_type: this.ruleForm.course_state,
        className: this.ruleForm.classname,
        lecturer_id: this.ruleForm.lecturer_id,
        subject_id: this.ruleForm.subject_id,
        curriculum_id: this.ruleForm.curriculum_id,
        teaching_type: this.ruleForm.teaching_type,
        class_start_time_begin: this.ruleForm.startdate
          ? this.ruleForm.startdate[0]
          : null,
        class_start_time_end: this.ruleForm.startdate
          ? this.ruleForm.startdate[1]
          : null,

        class_end_time_begin: this.ruleForm.enddate
          ? this.ruleForm.enddate[0]
          : null,
        class_end_time_end: this.ruleForm.enddate
          ? this.ruleForm.enddate[1]
          : null,
        end_class_state: this.ruleForm.end_class_state,
        page_no: this.page_no2,
        page_size: this.page_size2,
      }).then((res) => {
        this.tableData1 = res.class_list
        this.total2 = res.total

        console.log('查询班级列表')
        console.log(res)
      })
    },

    // 具有科目权限及课程体系的老师
    getCampusTeacherList() {
      api_eduCampusSelectTchListByCampus({
        eduCampusIdList: this.$store.state.user.selected_schools,
      }).then((res) => {
        this.teacherList = res
      })
    },

    //数组对象去重
    unique(arr) {
      const res = new Map()
      return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1))
    },

    ClassChooseChange() {
      if (this.form1.classnames == '') {
        this.form1.classIds = []
      }
    },

    handleClick() { },
    handleSizeChange(val) {
      this.page_size = val
      this.getFormalStudentList()
    },
    handleCurrentChange(val) {
      this.page_no = val
      this.getFormalStudentList()
    },

    handleCurrentChange1(val) {
      this.page_no1 = val
      this.getClassListForStuChangeClass()
    },

    handleCurrentChange2(val) {
      this.page_no2 = val
      this.getClassesList()
    },

    editStudent() { },

    //获得学员带参二维码
    getQrCode(row) {
      console.log('学员信息')
      console.log(row)
      console.log(row.id)

      this.stu_name = row.studentUserInfo.realname

      getQrCode({
        stuId: row.id,
      }).then((res) => {
        console.log('绑定学员家长微信')
        console.log(res)

        this.code_url =
          'data:image/jpeg;base64,' +
          this.arrayBufferToBase64(res.qucodeData.data)
        console.log('url', this.code_url)

        this.dialogVisible1 = true
      })
    },

    deleteStuUserOpenId(row) {
      deleteStuUserOpenId({
        stuId: row.id,
      }).then((res) => {
        console.log('解除绑定')
        console.log(res)
        if (res.is_delete) {
          this.$message.success('解绑成功')
          this.getFormalStudentList()
        }
      })
    },

    arrayBufferToBase64(buffer) {
      let binary = ''
      const bytes = new Uint8Array(buffer)
      const len = bytes.byteLength
      for (let i = 0; i < len; i += 1) {
        binary += String.fromCharCode(bytes[i])
      }
      return window.btoa(binary) //base64
    },

    ChangeClass(row) {
      console.log('调班')
      console.log(row)
      this.educational_institution_campus_id =
        row.educational_institution_campus_id
      this.getStudentNormalClassList(row.id)
    },

    //查询学员所有正式班级
    getStudentNormalClassList(id) {
      getStudentNormalClassList({
        student_user_id: id,
      }).then((res) => {
        console.log('查询学员正式班级')
        console.log(res)

        if (res.stuClassList.length == 0) {
          this.$message.warning('暂无在读班级')
        } else {
          this.stuClassList = res.stuClassList
          this.outerVisible1 = true
        }
      })
    },
    //删除学员
    deleteStudents() {
      if (this.chooseStu_current.length == 0) {
        this.$message({
          message: '请选择要删除的学员',
          type: 'warning',
        })
        return
      }

      this.$confirm(
        '确定要删除选中的学员吗? 谨慎操作,删除后数据不可恢复!',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        deleteStudents({
          studentIds: JSON.stringify(this.chooseStu_current),
        }).then((res) => {
          console.log('删除正式学员')
          console.log(res)
          if (res.is_delete) {
            if (res.failArr.length == 0) {
              this.$message.success('删除成功')
            } else {
              for (let k = 0; k < res.failArr.length; k++) {
                this.$notify({
                  title:
                    '警告:' + this.chooseStudents[k].studentUserInfo.realname,
                  message: res.failArr[k].failReason,
                  type: 'warning',
                  duration: 0,
                  offset: k * 100 + 100,
                })
              }
            }
            this.getFormalStudentList()
          }
        })
      })
    },

    //打开批量导入窗口
    OpenMultiAdd() {
      if (this.$store.state.user.selected_schools.length == 0) {
        this.$message.warning('请在左上角,选择目标校区')
        return
      } else if (this.$store.state.user.selected_schools.length > 1) {
        this.$message.warning('请在左上角,选择1个目标校区')
        return
      }

      this.dialogVisible = true
    },

    //移除批量导入学员
    Deleteoutputs(index) {
      console.log('移除批量导入学员')
      this.outputs.splice(index, 1)
    },

    //确认添加
    MultiAddStudent() {
      console.log('确认添加学员')
      console.log(this.outputs)
      this.has_error = false

      if (this.outputs.length == 0) {
        this.$message.warning('请录入学员信息')
        return
      } else if (this.outputs.length > 50) {
        this.$message.warning('单次批量添加学员,最大数量为50人')
        return
      } else {
        for (let k = 0; k < this.outputs.length; k++) {
          this.checkUsername(this.outputs[k].username)
          this.checkRealname(this.outputs[k].realname)
          this.checkSex(this.outputs[k].sex)
        }

        if (this.has_error) {
          return
        }

        var stuArr = [] //学员信息
        var stu = {
          realname: '',
          name: '',
          sex: '',
          campusId: '',
        }

        for (let k = 0; k < this.outputs.length; k++) {
          stu = {
            realname: this.outputs[k].realname,
            name: this.outputs[k].username,
            sex: this.outputs[k].sex,
            campusId: this.$store.state.user.selected_schools[0],
          }

          stuArr.push(stu)
        }

        console.log('批量导入学员信息')
        console.log(stuArr)

        bulkAddNormalStudent({
          stuArr: JSON.stringify(stuArr),
        }).then((res) => {
          console.log('批量导入学员')
          console.log(res)
          if (res.is_create) {
            if (res.failArr.length == 0) {
              this.$message.success('添加成功')
              this.dialogVisible = false
            } else {
              console.log('添加失败')
              for (let k = 0; k < res.failArr.length; k++) {
                setTimeout(() => {
                  this.$notify({
                    title: '警告',
                    message:
                      this.outputs[k].realname + ',' + res.failArr[k].msg,
                    type: 'warning',
                  })
                }, 100)
              }
              //取数组交集,仅保留失败的数据
            }

            this.$message.success(
              '导入成功' +
              (this.outputs.length -
                res.failArr.length +
                '个,' +
                '失败' +
                res.failArr.length +
                '个')
            )
            this.getFormalStudentList()
          }
        })
      }
    },

    //清除批量导入学员
    ClearMultiStudent() {
      this.outputs = []
      this.dialogVisible = false
    },

    //下载Excel模板

    DownLoadExcel() {
      window.open(
        'https://wugecdn.steam.fun/resources/static/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E5%AD%A6%E5%91%98.xls',
        '_blank'
      )
    },

    //更新表格状态
    tableRowClassName({ row, rowIndex }) {
      console.log('表格信息')
      console.log(row)
      console.log(rowIndex)

      if (this.checkUsername(row.username)) {
        return ''
      } else {
        return 'warning-row'
      }
    },

    //批量导入功能
    //文件选择时
    onChange(file, fileList) {
      this.fileData = file // 保存当前选择文件
      console.log(fileList)
      this.readExcel() // 调用读取数据的方法
    },

    //读取文件数据
    readExcel(e) {
      let that = this
      console.log(e)
      const files = that.fileData
      if (!files) {
        //如果没有文件
        return false
      } else if (!/\.(xls|xlsx)$/.test(files.name.toLowerCase())) {
        this.$message.error('上传格式不正确，请上传xls或者xlsx格式')
        return false
      }
      const fileReader = new FileReader()
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result
          const workbook = XLSX.read(data, {
            type: 'binary',
          })
          //导入的文件名称
          console.log(workbook.SheetNames)
          const wsname = workbook.SheetNames[0] //取第一张表
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]) //生成json表格内容
          that.outputs = [] //清空接收数据
          for (var i = 0; i < ws.length; i++) {
            var sheetData = {
              // 键名为绑定 el 表格的关键字，值则是 ws[i][对应表头名]
              //此处的字段名对应 上面表格数据的字段名
              realname: ws[i]['姓名'],
              sex: ws[i]['性别'],
              username: ws[i]['账号'],
            }
            that.outputs.push(sheetData)
          }
          console.log('导入的学员')
          console.log(that.outputs)
        } catch (e) {
          console.log(e)
          return false
        }
      }
      // 如果为原生 input 则应是 files[0]
      fileReader.readAsBinaryString(files.raw)
    },

    //检测账号规范
    checkUsername(value) {
      if (!value) {
        this.$message.warning('账号不能为空')
        this.has_error = true
        return false
      }
      if (!/^[a-zA-Z0-9]{6,20}$/.test(value)) {
        this.$message.warning('账号必须为6-20位字母或数字组成')
        this.has_error = true
        return false
      }
      if (!this.checkSpecialKey(value)) {
        this.$message.warning('不能含有特殊字符！！')
        this.has_error = true
        return false
      }

      return true
    },

    checkRealname(value) {
      if (!value) {
        this.$message.warning('姓名不能为空')
        this.has_error = true
        return false
      }
      if (!this.checkSpecialKey(value)) {
        this.$message.warning('不能含有特殊字符！！')
        this.has_error = true
        return false
      }
    },

    checkSex(value) {
      if (!value) {
        this.$message.warning('性别不能为空')
        this.has_error = true
        return false
      }
      if (value !== '男' && value !== '女') {
        this.$message.warning("性别请填'男' 或 '女'")
        this.has_error = true
        return false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.listen-test-management1 {
  background-color: #fff;
  margin: 10px;
  border-radius: 5px;
  section {
    padding-top: 10px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;

    .form-style {
      margin-top: 10px;
      width: 100%;
    }

    .table-style {
      margin-top: 20px;
    }
  }
  .form-style-open {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
    font-size: 12px;
    padding-right: 5px;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
}
</style>

<style>
.listen-test-management1 .el-divider--horizontal {
  margin-bottom: 20px;
  margin-top: 5px;
}

.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
